module.exports = __webpack_public_path__ + "static/media/ly.ae438f5a.svg";